import React from 'react';
import { MinusCircle, Plus } from 'lucide-react';
import { shortMarket } from './selectionKind';

const fmtDay = (d) => (d && /^\d{4}-\d{2}-\d{2}$/.test(d) ? `${d.slice(8, 10)}/${d.slice(5, 7)}` : d || '');

export const OutcomeBadge = ({ market }) => {
  const { o, g } = shortMarket(market);
  return (
    <span className="w-20 shrink-0 rounded-xl bg-[#F5A623] text-[#1A1A1A] px-1.5 py-1.5 text-center flex flex-col justify-center" data-testid="editor-outcome-badge">
      <span className="block text-sm font-black leading-tight break-words line-clamp-2">{o || '—'}</span>
      {g && <span className="block text-[9px] font-bold uppercase leading-tight truncate opacity-80">{g}</span>}
    </span>
  );
};

export const MatchInfo = ({ p }) => (
  <span className="flex-1 min-w-0">
    <span className="block text-[10px] text-gray-500 font-bold uppercase tracking-wider truncate">{p.league_name || ''}{p.match_date ? ` · ${fmtDay(p.match_date)} ${p.match_time || ''}` : ''}</span>
    <span className="block text-sm text-white font-bold truncate">{p.home_team} - {p.away_team}</span>
    {!p.fixture_id && <span className="block text-[11px] text-red-400 font-bold">Partita non trovata · tocca per cercarla</span>}
  </span>
);

const Minus = ({ onClick, testid }) => (
  <button type="button" onClick={onClick} className="p-2 text-gray-500 hover:text-red-400 shrink-0" aria-label="Togli" data-testid={testid}><MinusCircle className="w-5 h-5" /></button>
);

// Singola/Multipla: one row per bet
export const MultiRow = ({ p, i, onOpen, onRemove }) => (
  <div className="flex items-center gap-2 py-2" data-testid={`editor-row-${i}`}>
    <button type="button" onClick={onOpen} className="flex-1 min-w-0 flex items-center gap-3 text-left" data-testid={`editor-row-open-${i}`}>
      <OutcomeBadge market={p.market} />
      <MatchInfo p={p} />
    </button>
    <Minus onClick={onRemove} testid={`editor-row-remove-${i}`} />
  </div>
);

// Sistema: one block per match, its bets below, the "F" (Fissa) box and "Aggiungi scommessa"
export const SystemGroup = ({ g, onOpenMatch, onOpenBet, onRemoveBet, onRemoveMatch, onAddBet, onToggleFixed }) => (
  <div className="py-2" data-testid={`editor-group-${g.key}`}>
    <div className="flex items-center gap-2">
      <label className={`w-10 h-10 shrink-0 rounded-xl border-2 flex items-center justify-center font-black text-sm cursor-pointer ${g.fixed ? 'bg-[#F5A623] border-[#F5A623] text-[#1A1A1A]' : 'border-white/20 text-gray-400'}`} data-testid={`editor-fixed-${g.key}`}>
        <input type="checkbox" checked={g.fixed} onChange={onToggleFixed} className="sr-only" disabled={!g.first.fixture_id} />F
      </label>
      <button type="button" onClick={onOpenMatch} className="flex-1 min-w-0 text-left"><MatchInfo p={g.first} /></button>
      <Minus onClick={onRemoveMatch} testid={`editor-group-remove-${g.key}`} />
    </div>
    <div className="ml-12 mt-1 space-y-1">
      {g.items.map(({ p, i }) => (
        <div key={i} className="flex items-center gap-2" data-testid={`editor-bet-${i}`}>
          <button type="button" onClick={() => onOpenBet(i)} className="flex-1 min-w-0 flex items-center gap-2 text-left" data-testid={`editor-bet-open-${i}`}>
            <OutcomeBadge market={p.market} />
            <span className="text-xs text-gray-400 truncate">{p.market}</span>
          </button>
          <Minus onClick={() => onRemoveBet(i)} testid={`editor-bet-remove-${i}`} />
        </div>
      ))}
      {g.first.fixture_id && (
        <button type="button" onClick={onAddBet} className="flex items-center gap-1.5 text-xs font-black text-[#F5A623] py-1.5" data-testid={`editor-add-bet-${g.key}`}>
          <Plus className="w-4 h-4" /> Aggiungi scommessa
        </button>
      )}
    </div>
  </div>
);

export const groupPicks = (picks) => {
  const out = [];
  picks.forEach((p, i) => {
    const key = p.fixture_id ? String(p.fixture_id) : `nf${i}`;
    let g = out.find((x) => x.key === key);
    if (!g) { g = { key, first: p, items: [], fixed: !!p.fixed }; out.push(g); }
    g.items.push({ p, i });
  });
  return out;
};
